import { selectCommercialBillingApiRoute } from '@/components/SiderMenu/utils/sessionNavigation';
import { initialPagination, initialState, makeListReducers } from '@/models/utils';
import { bindServices } from '@/services/api';
import CoreQueries from '@/utils/input/queries';

import { DEFAULT_ORDER_BY, MODEL_NAME, NAVIGATION_KEY } from './constants';
import { filtersConfig } from './utils';

const api = bindServices(MODEL_NAME);
const pagedQuery = CoreQueries.ChannelReferralAgent.paged;

/** Pattern X — hand-rolled read-only model; API base from commercial billing session navigation. */
const moduleInitialState = {
  ...initialState,
  list: [],
  orderBy: DEFAULT_ORDER_BY,
  select: pagedQuery.select,
  searchSelect: pagedQuery.searchSelect,
  showForm: false,
  detail: false,
  id: null,
  item: null,
  success: false,
  activatingItemIds: {},
  filtersConfig,
};

const ChannelReferralAgentsModel = {
  namespace: MODEL_NAME,
  state: moduleInitialState,

  effects: {
    *fetchList({ payload }, { call, put, select }) {
      try {
        const fetchRoute = yield* selectCommercialBillingApiRoute(NAVIGATION_KEY, select);
        if (!fetchRoute) return;

        const pagination = yield select((state) => state[MODEL_NAME].pagination);
        const pageSize = yield select((state) => state.global.pageSize);
        const res = yield call(api.getAll, {
          route: `${fetchRoute}/paged`,
          params: {
            limit: pageSize,
            ...pagedQuery,
            ...pagination,
            ...payload,
          },
          readPriority: true,
        });

        const items = res?.items || res?.data || [];
        yield put({
          type: 'queryData',
          payload: {
            ...res,
            items,
            limit: pageSize,
            page: payload.page,
            totalCount: res?.totalCount ?? res?.count ?? res?.total ?? items.length,
          },
        });
      } catch (e) {
        /*  */
      }
    },

    *fetchItem({ payload }, { call, put, select }) {
      try {
        const fetchRoute = yield* selectCommercialBillingApiRoute(NAVIGATION_KEY, select);
        if (!fetchRoute) return;

        yield put({ type: 'success', payload: false });
        const res = yield call(api.getById, {
          route: fetchRoute,
          id: payload.id,
          params: {
            ...(payload.detail ? CoreQueries.ChannelReferralAgent?.itemDetail : {}),
            ...(payload?.params && { ...payload.params }),
          },
        });
        const item = Array.isArray(res) ? res[0] : res;
        yield put({ type: 'queryItem', payload: item });
      } catch (e) {
        /*  */
      }
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'queryOrderBy',
        payload,
      });
    },

    *showForm({ payload }, { put }) {
      yield put({
        type: 'queryShowForm',
        payload,
      });
    },

    *resetState(_, { put }) {
      yield put({ type: 'reset' });
    },
  },

  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: moduleInitialState,
    }),
    setFiltersConfig(state, { payload }) {
      return {
        ...state,
        filtersConfig: payload,
      };
    },
  },
};

export default ChannelReferralAgentsModel;
